import { type FC } from 'react';
import {
  Images
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconImagesProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconImages: FC<UiIconImagesProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Images}
      {...props}
    />
  );
};
